<template>
<div class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Region replications</span>
                <!-- <span v-if="snapshot" class="default-settings-subtitle">The snapshot <b>{{ snapshot.name }}</b> is configured to be replicated in {{ replications.count }} additional {{ regionWord }}.</span> -->
                <span v-if="snapshot" class="default-settings-subtitle">At the moment it was taken, the snapshot <b>{{ snapshot.name }}</b> was configured to be replicated in {{ replications.count }} additional {{ regionWord }}. For DigitalOcean, it doesn't cost more to replicate a snapshot to more regions.</span>
            </div>

            <div v-if="loadingReplications" class="columns m-top-15">
                <div class="column is-full has-text-centered">
                    <img src="/loader-dark.svg">
                </div>
            </div>
            <div v-if="!loadingReplications" class="columns is-multiline m-top-15">
                <div class="column is-3" v-for="replication in replications.data">
                    <div class="region">
                        <div class="region-flag">
                            <img :src="require('@/assets/img/regions/' + replication.region.slug + '.svg')">
                        </div>
                        <div class="region-name">
                            {{ replication.region.slug }}
                        </div>
                        <div class="replication-status tooltip is-tooltip-top is-tooltip-multiline" :data-tooltip="replicationTooltip(replication)" :class="{ 'replication-completed': replication.completed, 'replication-in-progress': replication.in_progress, 'replication-errored': replication.failed }">
                            <font-awesome-icon v-show="replication.completed || replication.failed" icon="circle"/>
                            <font-awesome-icon v-show="replication.in_progress" :icon="['far', 'circle']"/>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';

export default {
    data() {
        return {
            snapshot: null,
            replications: [],
            loadingReplications: true,
            active: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        getReplications() {
            let endpoint = 'snapshots/' + this.snapshot.id + '/replications';

            Api().get(endpoint)
                .then((response) => {
                    this.replications = response.data;
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    this.loadingReplications = false;
                });
        },

        show() {
            this.active = true;
            this.getReplications();
        },

        close() {
            this.active = false;
            this.reset();
        },

        reset() {
            this.replications = [];
            this.loadingReplications = true;
        },

        replicationTooltip(replication) {
            if (replication.completed) {
                return 'Snapshot replication in this region completed.';
            }

            if (replication.in_progress) {
                return 'Snapshot replication in this region is in progress.';
            }

            if (replication.failed) {
                return 'Snapshot replication in this region failed. Usually, the replication fails when you try to replicate the snapshot in the same region where the cloudlet is located.';
            }
        },

        listenEvents() {
            Event.$on('showReplicationsModal', (snapshot) => {
                this.snapshot = snapshot;
                this.show();
            });
        },
    },

    computed: {
        regionWord() {
            if (this.replications.count > 1) {
                return 'regions';
            }
            return 'region';
        },
    },

    watch: {
        snapshot(snapshot) {
            if (snapshot) {
                this.getReplications();
            }
        },
    },
}
</script>
